var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWorkspaceCBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 10,
    fill: "#E9EBED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6953 20.5312C17.8516 20.9688 16.8021 21.1875 15.5469 21.1875C13.9219 21.1875 12.6198 20.6745 11.6406 19.6484C10.6615 18.6224 10.1719 17.276 10.1719 15.6094C10.1719 13.8177 10.7214 12.3698 11.8203 11.2656C12.9245 10.1615 14.3177 9.60938 16 9.60938C17.0833 9.60938 17.9818 9.76302 18.6953 10.0703V11.9141C17.9401 11.4661 17.1068 11.2422 16.1953 11.2422C14.9818 11.2422 13.9974 11.6302 13.2422 12.4062C12.4922 13.1823 12.1172 14.2188 12.1172 15.5156C12.1172 16.75 12.4688 17.7344 13.1719 18.4688C13.875 19.1979 14.7995 19.5625 15.9453 19.5625C17.0026 19.5625 17.9193 19.3125 18.6953 18.8125V20.5312Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkspaceCBlack);
export default __webpack_public_path__ + "static/media/Icon_WorkspaceC_Black.247bc1549e9e7207ba94a4f018abcf8a.svg";
export { ForwardRef as ReactComponent };